(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Eventos heredados que aún usan el contenedor existente.
  function track(evento, datos) {
    window.dataLayer = window.dataLayer || [];
    var carga = { event: evento };
    for (var k in datos) { if (Object.prototype.hasOwnProperty.call(datos, k)) carga[k] = datos[k]; }
    window.dataLayer.push(carga);
  }

  // Eventos personalizados de Shopify para el nuevo píxel / GTM / GA4.
  function publishWhatsapp(datos) {
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish('whatsapp_click', datos);
    }
  }

  /* ---------- Ayuda para elegir: 3 preguntas y mensaje de WhatsApp ---------- */
  function initAyuda() {
    document.querySelectorAll('.mm-ayuda').forEach(function (panel) {
      var cta = panel.querySelector('.mm-ayuda__cta');
      var selects = panel.querySelectorAll('select[data-q]');
      var telefono = panel.getAttribute('data-wa-phone');
      var titulo = panel.getAttribute('data-product-title');
      var productId = panel.getAttribute('data-product-id');
      var url = panel.getAttribute('data-product-url');
      if (!cta) return;

      function mensaje() {
        var partes = ['Hola, necesito ayuda para elegir un arreglo.'];
        selects.forEach(function (s) {
          if (s.value) partes.push(s.getAttribute('data-q') + ': ' + s.value + '.');
        });
        if (titulo) partes.push('Estoy viendo: ' + titulo + ' (' + url + ').');
        return partes.join(' ');
      }
      function actualizar() {
        cta.href = 'https://api.whatsapp.com/send?phone=' + telefono + '&text=' + encodeURIComponent(mensaje());
      }

      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
      cta.addEventListener('click', function () {
        actualizar();

        publishWhatsapp({
          whatsapp_source: 'shopping_assistance',
          product_name: titulo || '',
          product_id: productId || ''
        });
      });
      actualizar();
    });
  }

  /* ---------- WhatsApp de Coronas Express ---------- */
  function initExpressWhatsapp() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"]');
      if (!link) return;

      if (link.id === 'whatsapp-buy-btn' || link.classList.contains('mm-ayuda__cta')) return;

      if (link.classList.contains('mm-faq__btn')) {
        publishWhatsapp({
          whatsapp_source: 'faq',
          product_name: link.getAttribute('data-product-title') || '',
          product_id: link.getAttribute('data-product-id') || ''
        });
        return;
      }

      if (link.closest('.text-footer, .custom-content-footer')) {
        publishWhatsapp({ whatsapp_source: 'footer_help', product_name: '', product_id: '' });
        return;
      }

      var href = link.getAttribute('href') || '';
      var texto = (link.textContent || '').replace(/\s+/g, ' ').trim();

      if (/Corona(?:%20|\s)Express|modelo(?:%20|\s)similar/i.test(href) || /Consultar por WhatsApp/i.test(texto)) {
        publishWhatsapp({
          whatsapp_source: 'express_availability',
          product_name: '',
          product_id: ''
        });
      }
    });
  }

  /* ---------- Barra fija en móvil: lleva a elegir fecha y horario ---------- */
  function initBarraFija() {
    var atc = document.getElementById('add-to-cart-btn');
    if (!atc) return;

    var mq = window.matchMedia('(max-width: 767px)');
    var bloque = document.querySelector('.custom-container') || atc;
    var precioEl = document.querySelector('.m-main-product--info .m-price-item--sale');

    var barra = document.createElement('div');
    barra.className = 'mm-sticky-bar';
    barra.setAttribute('role', 'region');
    barra.setAttribute('aria-label', 'Continuar con el pedido');
    var precio = document.createElement('div');
    precio.className = 'mm-sticky-bar__price';
    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'mm-sticky-bar__btn';
    barra.appendChild(precio);
    barra.appendChild(boton);
    document.body.appendChild(barra);
    document.body.classList.add('mm-has-sticky-bar');

    function estado() {
      boton.textContent = atc.disabled ? 'Completar pedido' : 'Añadir al carrito';
      precio.textContent = precioEl ? precioEl.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    estado();
    new MutationObserver(estado).observe(atc, { attributes: true, attributeFilter: ['disabled'] });

    boton.addEventListener('click', function () {
      track('sticky_bar_click', { accion: atc.disabled ? 'ir_a_selectores' : 'agregar_al_carrito' });
      if (atc.disabled) {
        var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        bloque.scrollIntoView({ behavior: reducir ? 'auto' : 'smooth', block: 'start' });
      } else {
        atc.click();
      }
    });

    // Se muestra solo cuando el botón principal de compra no está a la vista
    var visible = true;
    function aplicar() { barra.classList.toggle('is-visible', mq.matches && !visible); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        visible = entradas[0].isIntersecting;
        aplicar();
      }, { threshold: 0.1 }).observe(atc);
    }
    if (mq.addEventListener) mq.addEventListener('change', aplicar);
    else if (mq.addListener) mq.addListener(aplicar);
    aplicar();
  }


  /* ---------- Etiqueta de descuento: solo desde 5% ---------- */
  function ocultarDescuentosBajos(raiz) {
    (raiz || document).querySelectorAll('.m-product-tag--sale').forEach(function (tag) {
      var m = (tag.textContent || '').match(/(\d+)\s*%/);
      if (m && parseInt(m[1], 10) < 5) {
        var cont = tag.closest('.m-price__badge-sale') || tag;
        cont.style.display = 'none';
      }
    });
  }

  /* ---------- Fecha de entrega: calendario (flatpickr), hora de Lima y límite de 5:30 p. m. ---------- */
  var HORA_LIMITE = 17.5; // 5:30 p. m.
  // Días sin servicio (formato AAAA-MM-DD), por ejemplo: ['2026-12-25']
  var FECHAS_NO_DISPONIBLES = [];

  function ahoraLima() {
    var o = {};
    new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Lima', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    return { fecha: o.year + '-' + o.month + '-' + o.day, hora: (parseInt(o.hour, 10) % 24) + parseInt(o.minute, 10) / 60 };
  }

  function diaSiguiente(iso) {
    var d = new Date(iso + 'T12:00:00Z');
    d.setUTCDate(d.getUTCDate() + 1);
    return d.toISOString().slice(0, 10);
  }

  function localeEs() {
    var es = window.flatpickr && window.flatpickr.l10ns && window.flatpickr.l10ns.es;
    if (!es) return 'default';
    var loc = Object.assign({}, es, { firstDayOfWeek: 0 });
    loc.months = { shorthand: es.months.shorthand.slice(), longhand: es.months.longhand.slice() };
    loc.months.longhand[8] = 'Setiembre';
    loc.months.shorthand[8] = 'Set';
    return loc;
  }

  function initFecha() {
    var f = document.querySelector('input[name="properties[Fecha]"]');
    if (!f) return;

    // Aviso de hora límite
    var aviso = document.createElement('p');
    aviso.className = 'mm-corte';
    aviso.setAttribute('role', 'status');
    aviso.hidden = true;
    aviso.textContent = 'Ya pasó la hora límite para pedidos de hoy (5:30 p. m.). La primera fecha disponible es mañana.';
    var caja = f.closest('.fecha-horario-container');
    if (caja && caja.parentNode) caja.parentNode.insertBefore(aviso, caja.nextSibling);

    function limites() {
      var t = ahoraLima();
      var paso = t.hora >= HORA_LIMITE;
      return { paso: paso, min: paso ? diaSiguiente(t.fecha) : t.fecha };
    }

    var calendario = null;
    var hint = null;

    if (window.flatpickr && f.type === 'date') {
      // Calendario propio: días pasados en gris, en español, sin teclado en el celular
      calendario = window.flatpickr(f, {
        locale: localeEs(),
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'D j M Y',
        altInputClass: 'mm-fecha-alt',
        disableMobile: true,
        static: true,
        minDate: limites().min,
        disable: FECHAS_NO_DISPONIBLES,
        onOpen: function () { aplicar(); }
      });
      calendario.altInput.setAttribute('placeholder', 'Selecciona el día');
      calendario.altInput.setAttribute('aria-label', 'Elige el día de entrega');
      calendario.calendarContainer.classList.add('mm-calendario');
    } else if (window.matchMedia('(pointer: coarse)').matches) {
      // Respaldo: campo nativo con texto guía
      var wrap = document.createElement('div');
      wrap.className = 'mm-date-wrap';
      f.parentNode.insertBefore(wrap, f);
      wrap.appendChild(f);
      hint = document.createElement('span');
      hint.className = 'mm-date-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.textContent = 'Selecciona el día';
      wrap.appendChild(hint);
    }

    function aplicar() {
      var l = limites();
      if (calendario) calendario.set('minDate', l.min);
      else f.min = l.min;
      if (f.value && f.value < l.min) {
        if (calendario) calendario.clear();
        else {
          f.value = '';
          f.dispatchEvent(new Event('input', { bubbles: true }));
          f.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      aviso.hidden = !l.paso;
      if (!calendario) {
        f.classList.toggle('mm-date-empty', !f.value);
        if (hint) hint.hidden = !!f.value;
        f.min = l.min;
      }
    }

    if (!calendario) ['input', 'change', 'focus', 'blur'].forEach(function (ev) { f.addEventListener(ev, aplicar); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) aplicar(); });
    aplicar();
  }

  /* ---------- WhatsApp de la ficha: mensaje con los datos que el cliente ya completó ---------- */
  function initWhatsappCompra() {
    var a = document.getElementById('whatsapp-buy-btn');
    if (!a) return;
    var telefono = ((a.getAttribute('href') || '').match(/phone=(\d+)/) || [])[1] || '51922194330';
    var titulo = a.getAttribute('data-product-title') || document.title;
    var enlace = window.location.origin + window.location.pathname;

    function valor(selector) {
      var el = document.querySelector(selector);
      return el && el.value ? String(el.value).replace(/\s+/g, ' ').trim() : '';
    }

    function fechaLegible(iso) {
      if (!iso) return '';
      var d = new Date(iso + 'T12:00:00Z');
      if (isNaN(d.getTime())) return iso;
      var t = d.toLocaleDateString('es-PE', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
      return t.charAt(0).toUpperCase() + t.slice(1);
    }

    function mensaje() {
      var datos = [];
      function agregar(etiqueta, texto) { if (texto) datos.push('- ' + etiqueta + ': ' + texto); }

      agregar('Fecha de entrega', fechaLegible(valor('input[name="properties[Fecha]"]')));
      agregar('Horario', valor('select[name="properties[Horario]"]'));
      agregar('Base', valor('select[name="properties[Base]"]'));
      var tarjeta = document.querySelector('input[name="properties[Dedicatoria]"]:checked');
      agregar('Tarjeta', tarjeta ? tarjeta.value : '');
      agregar('De parte de', valor('#de-parte-de'));
      var conMensaje = document.getElementById('dedicatoria-checkbox');
      if (conMensaje && conMensaje.checked) {
        agregar('Nombre del fallecido', valor('#nombre-fallecido'));
        agregar('Mensaje en la tarjeta', valor('#dedicatoria-textarea-input'));
      }

      var lineas = ['Hola, quiero comprar: ' + titulo, enlace];
      if (datos.length) lineas.push('', 'Datos de mi pedido:');
      return lineas.concat(datos).join('\n');
    }

    function actualizar() {
      a.href = 'https://api.whatsapp.com/send?phone=' + telefono + '&text=' + encodeURIComponent(mensaje());
    }

    ['input', 'change'].forEach(function (ev) { document.addEventListener(ev, actualizar, true); });
    ['click', 'touchstart', 'mouseenter', 'focus'].forEach(function (ev) { a.addEventListener(ev, actualizar, true); });
    actualizar();
  }

  /* ---------- Oculta imágenes que no cargaron dentro del contenido ---------- */
  function ocultarImagenesRotas() {
    document.querySelectorAll('main img').forEach(function (img) {
      if (img.getAttribute('src') && img.complete && img.naturalWidth === 0 && img.offsetParent !== null) {
        img.style.display = 'none';
      }
    });
  }

  ready(function () {
    initAyuda();
    initExpressWhatsapp();
    initBarraFija();
    initFecha();
    initWhatsappCompra();
    ocultarDescuentosBajos();
    window.addEventListener('load', function () { setTimeout(ocultarImagenesRotas, 1500); });
    if ('MutationObserver' in window) {
      var pendiente = false;
      new MutationObserver(function () {
        if (pendiente) return;
        pendiente = true;
        setTimeout(function () { pendiente = false; ocultarDescuentosBajos(); }, 300);
      }).observe(document.body, { childList: true, subtree: true });
    }
  });
})();
